<script lang="ts" setup>
const { createEvent } = useAnalytics()
const { t } = useI18n()

onMounted(() => {
  createEvent({ name: '[Navigation] Visit Settings Webhooks' })
})
</script>

<template>
  <UCard>
    <UDashboardSection
      :description="t('webhooks.description')"
      orientation="horizontal"
      :title="t('webhooks.title')"
      :ui="{ wrapper: 'lg:grid-cols-1 xl:grid-cols-2 first:*:col-span-1 last:*:col-span-1 gap-8' }"
    >
      <template #links>
        <ApiWebhooksBoxForm />
      </template>

      <ApiWebhooksBox />
    </UDashboardSection>
  </UCard>
</template>

<i18n lang="json">
{
  "en": {
    "webhooks": {
      "description": "Create a webhook to receive a notification for the actions you woud like to track. For instance, when a new company has been analyzed or match one of your search filters.",
      "title": "Your team's webhooks"
    }
  },
  "es": {
    "webhooks": {
      "description": "Crea un webhook para recibir una notificación para los eventos que desees rastrear. Por ejemplo, cuando una nueva empresa haya sido analizada o coincida con uno de tus filtros de búsqueda.",
      "title": "Los webhooks de tu equipo"
    }
  },
  "fr": {
    "webhooks": {
      "description": "Créez un webhook pour recevoir une notification pour les événements que vous souhaitez suivre. Par exemple, lorsqu'une nouvelle entreprise a été analysée ou correspond à l'un de vos filtres de recherche.",
      "title": "Les webhooks de votre équipe"
    }
  }
}
</i18n>
